import React, { useState } from "react";
import PropTypes from "prop-types";
import Popup from "reactjs-popup";
import client from "../../../shared/api/client";

const modalContentStyle = {
  width: "460px",
  maxWidth: "92vw",
  borderRadius: "8px",
  padding: 0,
  background: "var(--sl-bg-primary)",
  color: "var(--sl-text-primary)",
};
const dividerStyle = { borderColor: "var(--sl-border-secondary)" };

const EditArtistSocial = ({ network, label, currentUrl, updateUrl, variant, iconClass }) => {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState(currentUrl || "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const openModal = () => {
    setUrl(currentUrl || "");
    setError(null);
    setOpen(true);
  };

  const save = () => {
    if (saving) return;
    setSaving(true);
    setError(null);
    client.patch(updateUrl, { network, url })
      .then(() => window.location.reload())
      .catch((e) => {
        setSaving(false);
        const res = e && e.response;
        setError((res && res.data && res.data[0]) || `Could not update the ${label} link.`);
      });
  };

  const trigger = variant === "chip" ? (
    <button
      type="button"
      className="btn social-add-chip d-flex align-items-center"
      aria-label={`Add ${label} link`}
      onClick={openModal}
    >
      {iconClass && <i className={`${iconClass} mr-2`} />}
      <span>{label}</span>
      <i className="fa fa-plus ml-2" />
    </button>
  ) : (
    <button
      type="button"
      className="btn btn-link p-0 social-edit-btn"
      title={`Edit ${label}`}
      aria-label={`Edit ${label}`}
      onClick={openModal}
    >
      <i className="fa fa-pencil" />
    </button>
  );

  return (
    <React.Fragment>
      {trigger}

      <Popup open={open} modal closeOnDocumentClick contentStyle={modalContentStyle} onClose={() => setOpen(false)}>
        <div className="popup-modal-container" data-testid="edit-social-modal">
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ padding: "16px", borderBottom: "2px solid", ...dividerStyle }}
          >
            <strong style={{ fontSize: "18px" }}>Edit {label} link</strong>
            <a href="#" onClick={(e) => { e.preventDefault(); setOpen(false); }} style={{ fontSize: "22px", lineHeight: 1 }}>×</a>
          </div>

          <div style={{ padding: "16px" }}>
            <label className="d-block mb-1"><small className="text-muted">{label} URL</small></label>
            <input
              type="text"
              className="form-control"
              data-testid="social-url-input"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder={`https://…`}
              autoFocus
            />
            <small className="text-muted">Leave blank to remove the link.</small>
            {error && <div className="text-danger small mt-2" data-testid="social-error">{error}</div>}
          </div>

          <div className="d-flex justify-content-end" style={{ padding: "12px 16px", borderTop: "2px solid", ...dividerStyle }}>
            <button type="button" className="btn btn-link mr-2" onClick={() => setOpen(false)}>Cancel</button>
            <button type="button" className="btn btn-primary" data-testid="social-save" disabled={saving} onClick={save}>
              {saving ? "Saving…" : "Save"}
            </button>
          </div>
        </div>
      </Popup>
    </React.Fragment>
  );
};

EditArtistSocial.propTypes = {
  network: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  currentUrl: PropTypes.string,
  updateUrl: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["pencil", "chip"]),
  iconClass: PropTypes.string,
};

EditArtistSocial.defaultProps = { currentUrl: null, variant: "pencil", iconClass: null };

export default EditArtistSocial;
